import axios from '../../config/axios';


function newPolicy(data) {
    return axios().post("/insurance/third-party-policies", data);
}

function getVehiclePolicy(vehicleId) {
    return axios().get("/insurance/vehicle-third-party-policy", {
        params: {
            vehicle_id: vehicleId
        }
    })
}

function cancel(insuranceId) {
    return axios().put(`/insurance/third-party-policies/${insuranceId}/cancel`)
}

function extend(policyId, data) {
    return axios().put(`/insurance/third-party-policies/${policyId}/extend`, data)
}

export default {
    newPolicy,
    getVehiclePolicy,
    cancel,
    extend
}